import { styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

export const StrengthIndicator = styled("div")(
  ({ strength }: { strength: number }) => ({
    backgroundColor: KahunColorMap.Secondary,
    width: strength * 100 + "%",
    maxWidth: "98.5%",
    position: "absolute",
    transition: "width 1s ease-in",
    opacity: 1,
    left: "7px", // Give the 14px border-radius some space
    bottom: 0,
    height: "5px",
    borderRadius: "5px",
  }),
);
